// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PageBlockLayer_overlay__399-U","message":"PageBlockLayer_message__csOxE"};